import { Component, OnInit } from '@angular/core';
import { ShoppingCartService } from 'shared/services/shopping-cart.service';
import { Observable } from 'rxjs';
import { ShoppingCart } from 'shared/models/shopping-cart';
import { slideCartItems, slideCart } from 'src/app/animations';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.css'],
  animations: [ slideCartItems, slideCart ]
})
export class ShoppingCartComponent implements OnInit {
  cart$: Observable<ShoppingCart>;

  isFirstTimeLoad: boolean = false;

  constructor(private shoppingCartService: ShoppingCartService) { }

  async ngOnInit() {
    this.cart$ = await this.shoppingCartService.getCart();
    // this.isFirstTimeLoad = null;
  }

  clearCart() {
    this.shoppingCartService.clearCart();
  }

}
